import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import Login from '@/views/auth/Login';
import LoginForm from '@/components/auth/LoginForm';
import ForgotPassword from '@/components/auth/ForgotPassword';
import ResetPassword from '@/components/auth/ResetPassword';
import Home from '@/views/Home';
import ResponseError from '@/views/error/ResponseError';
import Monitoring from '@/views/modules/Monitoring';
import Reservoirs from '@/views/modules/Reservoirs';
import Conservation from '@/views/modules/Conservation';
import Effluents from '@/views/modules/Effluents';
import StationsData from '@/views/modules/StationsData';
import Reports from '@/views/modules/Reports';
import Weather from '@/views/modules/Weather';
import RainEstimationHistoricalData from '@/views/modules/RainEstimationHistoricalData';
import Indicators from '@/views/modules/Indicators';
import UndergroundWaters from '@/views/modules/UndergroundWaters';
import Guides from '@/views/modules/Guides';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: routes.responseError.path,
    },
    {
      path: routes.login.path,
      component: Login,
      children: [
        {
          ...routes.login.children.loginForm,
          component: LoginForm,
        },
        {
          ...routes.login.children.forgotPassword,
          component: ForgotPassword,
        },
        {
          ...routes.login.children.resetPassword,
          component: ResetPassword,
        },
      ],
    },
    {
      path: routes.weather.path,
      name: routes.weather.name,
      component: Weather,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: routes.home.path,
      name: routes.home.name,
      component: Home,
      meta: {
        requiresAuth: true,
        authorize: routes.home.authorize,
      },
    },
    {
      name: routes.monitoring.name,
      path: routes.monitoring.path,
      component: Monitoring,
      meta: {
        requiresAuth: true,
        authorize: routes.monitoring.authorize,
      },
    },
    {
      name: routes.rainEstimationHistoricalData.name,
      path: routes.rainEstimationHistoricalData.path,
      component: RainEstimationHistoricalData,
      meta: {
        requiresAuth: true,
        authorize: routes.rainEstimationHistoricalData.authorize,
      },
    },
    {
      name: routes.reservoirs.name,
      path: routes.reservoirs.path,
      component: Reservoirs,
      meta: {
        requiresAuth: true,
        authorize: routes.reservoirs.authorize,
      },
    },
    {
      name: routes.conservation.name,
      path: routes.conservation.path,
      component: Conservation,
      meta: {
        requiresAuth: true,
        authorize: routes.conservation.authorize,
      },
    },
    {
      name: routes.effluents.name,
      path: routes.effluents.path,
      component: Effluents,
      meta: {
        requiresAuth: true,
        authorize: routes.effluents.authorize,
      },
    },
    {
      name: routes.indicators.name,
      path: routes.indicators.path,
      component: Indicators,
      meta: {
        requiresAuth: true,
        authorize: routes.indicators.authorize,
      },
    },
    {
      name: routes.stationsData.name,
      path: routes.stationsData.path,
      component: StationsData,
      meta: {
        requiresAuth: true,
        authorize: routes.stationsData.authorize,
      },
    },
    {
      name: routes.undergroundWaters.name,
      path: routes.undergroundWaters.path,
      component: UndergroundWaters,
      meta: {
        requiresAuth: true,
        authorize: routes.undergroundWaters.authorize,
      },
    },
    {
      name: routes.guides.name,
      path: routes.guides.path,
      component: Guides,
      meta: {
        requiresAuth: true,
        authorize: routes.guides.authorize,
      },
    },
    {
      name: routes.reports.name,
      path: routes.reports.path,
      component: Reports,
      meta: {
        requiresAuth: true,
        authorize: routes.reports.authorize,
      },
    },
    {
      ...routes.responseError,
      component: ResponseError,
      meta: {bothGuestAuth: true},
      props: true,
    },
  ],
});
